<template>
	<div class="basis-page-cls leave-messgae-index">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" pageNumber="pageNum" />
		</section>
		<div class="leave-message__table">
			<table-pagination
			   v-loading="loading"
				ref="tableItem"
				pagination
				layout="prev,pager,next"
				:data="data"
				:column="column"
				:total="total"
				:page.sync="listQuery.pageNum"
				:limit.sync="listQuery.pageSize"
				@pagination="getList">
					<template v-slot:action="{row}">
						<div class="operate-inline">
							<el-button type="text" size="small" @click="toDetail(row)">留言处理</el-button>
						</div>
					</template>
				</table-pagination>
		</div>
		<!-- 留言处理 -->
		<Details ref="details" v-model="detailsViewer.show" :source="detailsViewer.source" @confirm="onConfirm"/>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import {channel,leave_msg_status} from '../data.js';
	import Details from './details';
	export default {
		components:{
			Details
		},
		computed:{
			 ...mapGetters([
				'subBrandList',
				'skillGroupLists',
				'agentId',
				'userInfo'
			])
		},
		data(){
			return {
				detailsViewer:{
					show:false,
					source:null
				},
				filterHeader:[
					{label: '创建时间', model: 'date',default:'', type: 'datetimerange'},
					{label: '品牌', model: 'childBrand', type: 'select', default: '', list: [] },
					{label:'状态', model:'status', type: 'select', default: '',list:leave_msg_status},
					{label:'渠道', model:'channel', type: 'select', default: '',list:channel},
					{label: '技能组', model: 'skillGroup', type: 'select', default: '', list:[]},
				],
				listQuery:{
					date:'',
					status:'',
					brand:this.$store.state.user.brandId,
					childBrand:'',
					channel:'',
					skillGroup:'',
					pageNum:1,
					pageSize:10,
					startTime:'',
					endTime:'',
				},
				data:[],
				column:[
					{
					    label: '序号',
					    width: 80,
					    render: (h, scope) => {
					        return <span>{((this.listQuery.pageNum - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
					    }
					},{ 
						label: '留言时间', 
						prop: 'createTime',
						sortable: true,
						render:(h,scope) => {
							return <span>{this.$dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm")}</span>
						}
					},
					{ label: '访客', prop: 'name' },
					{ label: '品牌', prop: 'childBrandName' },
					{ label: '渠道', prop: 'channel',render:(h,scope)=>{return <span>{this.getChannel(scope.row.channel)}</span>} },
					{ label: '技能组', prop: 'skillGroupName'},
					{ label: '留言数', prop: 'leaveMsgNum'},
					{
						label: "留言状态",
						prop: "status",
						render: (h, scope) => {
							return (
							<span>
								 <el-link underline={false} type={this.getStatus(scope.row.status,'type')}>{this.getStatus(scope.row.status,'name')}</el-link>
							</span>
							);
						}
					},
					{ label: '操作人', prop: 'dealName'},
					{
						label: "操作",
						prop: "action",
						align: "center",
						width: 180,
						slotScope:true,
						fixed:'right',
					}
				],
				total:0,
				loading:false
			}
		},
		methods:{
			getChannel(key){
				let index = channel.findIndex(el => el.id == key);
				if(index != -1) return channel[index].name;
				return '暂无'
			},
			onConfirm(session){
				this.getList(session);
			},
			toDetail(row){
				this.detailsViewer = {
					show:true,
					source:row
				}
			},
			getList(session){
				this.loading = true;
				this.listQuery.startTime = this.listQuery.date ?  this.listQuery.date[0]: ""
				this.listQuery.endTime = this.listQuery.date ?  this.listQuery.date[1]: ""
				this.$api.getImLeaveMessageLists({
					data:this.listQuery,
					pageSize:this.listQuery.pageSize,
					pageNum:this.listQuery.pageNum,
					orderBy: "create_time",
				}).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.data = res.list
					this.total = res.total
					if(session) {
						const index = this.data.findIndex(el => el.session == session);
						if(index != -1) {
							this.$set(this.detailsViewer,'source',this.data[index]);
						}
					}
				})
			},
			filterSearch(query){
				this.listQuery = Object.assign(this.listQuery, query);
				if(this.listQuery.date) {
					this.getList();
					return
				}
				this.$message.warning("请先选择时间");
			},
			getStatus(status,key){
				let result = leave_msg_status.filter(el => el.id == status);
				if(result.length > 0) return result[0][key]
				return ''
			},
			getSkillGroup(){
				this.$api.apiGetSkillGroupLists({brandIdentify: this.userInfo.brandIdentify}).then(response => {
					for(const item of response.data) {
						this.filterHeader[4]['list'].push({
							id: item.skillId,
							name: item.skillName
						});
					}
				});
			}
		},
		async created(){
			let endTime = new Date();
			endTime.setHours(23,59,59);
			let startTime = new Date();
			startTime.setDate(startTime.getDate() - 30);
			startTime.setHours(0,0,0);
			this.listQuery.date = [startTime,endTime];
			this.filterHeader[0].default = this.listQuery.date;
			await this.getList()
			await this.getSkillGroup();
			this.filterHeader[1]['list'] = await this.subBrandList;
		}
	}
</script>

<style>
</style>